import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '../Store';

export const propertyProvince = (state: AppState) => state;

export const propertySelector = createSelector(propertyProvince, ({ property }) => property);
